var map = {
	"./avatar-helix.webp": "c581",
	"./avatar-wilson-chen.webp": "c03a",
	"./icon-connect.svg": "18eb",
	"./icon-copy.svg": "b43f",
	"./icon-discord-pink.svg": "75ea",
	"./icon-discord-white.svg": "13be",
	"./icon-telegram-pink.svg": "b4cc",
	"./icon-telegram-white.svg": "1cb8",
	"./icon-twitter-pink.svg": "9b6d",
	"./icon-twitter-white.svg": "494d",
	"./icon-website-pink.svg": "8ca1",
	"./icon-website-white.svg": "1607",
	"./icon-youtube-pink.svg": "6a42",
	"./icon-youtube-white.svg": "b4bf",
	"./img-babypig.webp": "16aa",
	"./img-roadmap.webp": "2e55",
	"./logo-baby-pig.webp": "0d0d",
	"./pig-all-m.webp": "94cf",
	"./pig-all.webp": "36e0",
	"./piggy-punks-poster.webp": "26b2",
	"./piggypunks-animation.gif": "762a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";